'use client'
// Résumé IA + liste d'articles récents (actualités par région). Extrait de app/page.tsx.
import { SectionLabel } from './SectionLabel'
import type { AiNews } from '@/types/landing'

function timeAgo(iso: string) {
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000)
  if (m < 1) return 'maintenant'
  if (m < 60) return `${m}m`
  return `${Math.floor(m / 60)}h`
}

/** Encart « Résumé IA » de Ti-Coune. null si pas de résumé. */
export function NewsSummary({ news }: { news: AiNews | null }) {
  if (!news?.summary) return null
  return (
    <div style={{
      padding: '14px 18px', marginBottom: '40px',
      background: 'rgba(79,124,255,0.06)', border: '1px solid rgba(79,124,255,0.2)',
      borderRadius: '10px', borderLeft: '3px solid var(--accent)',
    }}>
      <div style={{ fontSize: '10px', color: 'var(--accent)', fontFamily: 'var(--font-mono)', letterSpacing: '0.1em', marginBottom: '6px' }}>
        ◈ TI-COUNE · {news.region.toUpperCase()} · {news.fromCache ? 'CACHE' : 'LIVE'}
      </div>
      <p style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.6, fontFamily: 'var(--font-mono)', margin: 0 }}>
        {news.summary}
      </p>
    </div>
  )
}

/** Grille des articles récents (max 6). null si aucun. */
export function NewsList({ news }: { news: AiNews | null }) {
  if (!news || news.articles.length === 0) return null
  return (
    <section style={{ marginBottom: '48px' }}>
      <SectionLabel>Articles récents — {news.region}</SectionLabel>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '10px' }}>
        {news.articles.slice(0, 6).map(a => (
          <a key={a.id} href={a.url} target="_blank" rel="noopener noreferrer"
            style={{
              display: 'flex', gap: '12px', padding: '14px',
              background: 'var(--bg-card)', border: '1px solid var(--border-dim)',
              borderRadius: '10px', textDecoration: 'none', color: 'inherit',
              transition: 'border-color 0.15s, transform 0.15s',
            }}
            onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = 'rgba(79,124,255,0.4)'; el.style.transform = 'translateY(-2px)' }}
            onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = 'var(--border-dim)'; el.style.transform = 'none' }}
          >
            {a.urlImage && (
              <img src={a.urlImage} alt="" loading="lazy"
                onError={e => (e.currentTarget.style.display = 'none')}
                style={{ width: 72, height: 52, objectFit: 'cover', borderRadius: '6px', flexShrink: 0 }}
              />
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{ fontSize: '10px', color: 'var(--accent)', fontFamily: 'var(--font-mono)', fontWeight: 500 }}>
                  {a.source.nom}
                </span>
                <span style={{ fontSize: '9px', color: 'var(--text-muted)', fontFamily: 'var(--font-mono)', marginLeft: 'auto' }}>
                  {timeAgo(a.datePublication)}
                </span>
              </div>
              <div className="font-display" style={{
                fontSize: '13px', fontWeight: 600, color: 'var(--white)', lineHeight: 1.35,
                overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
              }}>
                {a.titre}
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  )
}
